export const messages = {
  en: {
    addExamineStaff: {
      title: 'Add Examine Staff',
      staffName: 'Staff Name',
      staffNamePlaceholder: 'Required, please fill in staff name',
      select: 'Select',
      projects: 'Examine Projects',
      staffAvatar: 'Staff Avatar',
      staffPost: 'Staff Post',
      staffPostPlaceholder: 'Required, please fill in staff post',
      staffIntroduction: 'Staff Introduction',
      staffIntroductionPlaceholder: 'Required, please fill in staff introduction'
    },
    uploadImage: {
      imageSizeLimit: 'Image size cannot exceed 2MB',
      uploadFailed: 'Upload failed'
    }
  },
  zh: {
    addExamineStaff: {
      title: '添加考核员工',
      staffName: '员工名称',
      staffNamePlaceholder: '必填，请填写员工名称',
      select: '选择',
      projects: '考核项目',
      staffAvatar: '员工头像',
      staffPost: '员工岗位',
      staffPostPlaceholder: '必填，请填写员工岗位',
      staffIntroduction: '员工简介',
      staffIntroductionPlaceholder: '必填，请输入员工简介'
    },
    uploadImage: {
      imageSizeLimit: '图片大小不能超过2MB',
      uploadFailed: '上传失败'
    }
  }
}